const validVin = vin => vin && vin.length === 17;

export default validVin;
